/**
 * The kinds of the errors shown, as soft filter chips with their counts
 * (19/10/2026): a dot in the tone's colour, picked chips tinted; several
 * can be picked; "All" clears. Hover says what the kind means.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenErrorRow } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

import { kindWords, TONE_COLOR } from '../errors-words';

const CHIP = 'inline-flex h-7 items-center gap-1.5 whitespace-nowrap rounded-md border px-2 text-[11.5px] transition-all duration-200 active:scale-95';
const ON = 'border-primary/50 bg-primary/10 font-medium text-primary';
const OFF = 'border-input text-muted-foreground hover:border-primary/40 hover:text-foreground';

export const KindChips: FC<{ rows: DropGenErrorRow[]; kinds: ReadonlySet<string>; onToggle: (kind: string) => void; onClear: () => void }> = ({ rows, kinds, onToggle, onClear }) => {
  const counts = new Map<string, number>();
  for (const r of rows) counts.set(r.kind, (counts.get(r.kind) ?? 0) + 1);
  const sorted = [...counts].sort((a, b) => b[1] - a[1]);
  return (
    <div role="group" aria-label="Kinds" className="flex flex-wrap items-center gap-1.5 border-t border-border/40 px-5 py-2.5" data-testid="kind-chips">
      <button type="button" aria-pressed={kinds.size === 0} onClick={onClear} className={cn(CHIP, kinds.size === 0 ? ON : OFF)}>
        All · {rows.length}
      </button>
      {sorted.map(([kind, n]) => {
        const w = kindWords(kind);
        return (
          <button key={kind} type="button" aria-pressed={kinds.has(kind)} title={w.hint} onClick={() => onToggle(kind)} className={cn(CHIP, kinds.has(kind) ? ON : OFF)}>
            <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: TONE_COLOR[w.tone] }} aria-hidden />
            {w.label} · {n}
          </button>
        );
      })}
    </div>
  );
};
